import firebaseApp from '../../utils/firebase'
import axios from 'axios/dist/axios'
import Raven from 'raven-js'

export default {
  toggleSound({
    getters
  }) {

    if (getters.bindUID)
      firebaseApp.ref.child('visitors')
      .child(getters.bindUID)
      .child('mute')
      .set(!getters.isMute)

  },
  doPopout({
    commit,
    getters
  }, popout) {

    if (getters.bindUID)
      firebaseApp.ref.child('visitors')
      .child(getters.bindUID)
      .child('popout')
      .set(popout)

  },
  requestNewChat({ getters }) {
    Raven.captureBreadcrumb({
      message: 'Requesting new chat',
      category: 'requests',
      data: {
        organization_id: getters.getOrgId,
        widget_id: getters.getWidgetId,
        uid: getters.bindUID
      }
    });

    return axios.post('@@API/visitor/session', {
      organization_id: getters.getOrgId,
      widget_id: getters.getWidgetId,
      uid: getters.bindUID
    })

  },
  requestTranscript({ getters }, email) {

    return axios.post('@@API/transcript/send/visitor', {
      organization_id: getters.getOrgId,
      session_id: getters.bindSID,
      email
    })

  }
}
